<template>
  <div class="flex items-center h-100" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <template v-if="status === 'null'">
    <stop-circle-icon
      size="1.3x"
      class="hover:text-primary cursor-pointer"
      @click="ChangeStatus('Approve')"
    />
    <play-circle-icon
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
      @click="ChangeStatus('Reject')"
    />
    </template>
    <stop-circle-icon
    v-else-if="status === 'run'"
      size="1.3x"
      class="hover:text-primary cursor-pointer ml-3"
    />
    <play-circle-icon
      v-else-if="status !== 'run'"
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
    />
  </div>
</template>

<script>
import {PlayCircleIcon,StopCircleIcon} from 'vue-feather-icons'

export default {
  name: 'CellRendererActions',
  components: {
    StopCircleIcon,
    PlayCircleIcon
  },
  computed: {
    status () {
      return this.params.data.status
    }
  },
  methods: {
    ChangeStatus (status) {
      this.$vs.loading()
      this.$store.dispatch(`smsTemplate/${status}`, this.params.data.sms_template_uuid)
      .then(() => {
        this.ShowSuccessMessage({ title: 'Success', text: `Template has been ${status === 'Reject' ? 'run' : 'fail'}` })
        this.params.data.refreshData()
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },
  }
}
</script>
